/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function Maximize2Icon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="maximize-2"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M14 10L20.5 3.5M20.5 3.5L20.5 8.096M20.5 3.5L15.904 3.5" data-tinysvg-shape="arrow" data-tinysvg-arrow="14 10 20.5 3.5 50" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M10 14L3.5 20.5M3.5 20.5L3.5 15.904M3.5 20.5L8.096 20.5" data-tinysvg-shape="arrow" data-tinysvg-arrow="10 14 3.5 20.5 50" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
